module.exports = __webpack_public_path__ + "static/media/chacha.8ed4178f.png";